angular.module('accessWebClient')
    .filter('templatePath', ['ENV', function(ENV) {
        var templatesPath = ENV['templatesPath'];

        return function(path) {
            return templatesPath + path + '.html';
        };
    }]);
